import React from 'react';
import NavbarLanding from '../components/NavbarLanding';
import Footer from './Footer';

const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <NavbarLanding />
      
      <div className="max-w-4xl mx-auto px-4 py-12">
        <div className="bg-white rounded-lg shadow-lg p-8">
          <h1 className="text-4xl font-bold text-gray-900 mb-8 text-center">
            Terms of Service
          </h1>
          
          <div className="prose prose-lg max-w-none">
            <div className="space-y-8">
              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                  1. Acceptance of Terms
                </h2>
                <p className="text-gray-700">
                  By accessing or using our website and services, you agree to follow these 
                  Terms of Service. If you do not agree, please stop using our site 
                  immediately.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                  2. Changes to Terms
                </h2>
                <p className="text-gray-700">
                  We may update these Terms at any time to reflect changes in our services, 
                  policies, or legal requirements. Continued use of the site means you accept 
                  any revised terms.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                  3. Use of Information
                </h2>
                <p className="text-gray-700">
                  All information on this website is provided for general purposes only. While 
                  we aim for accuracy, we do not guarantee completeness or reliability. Any 
                  use of this information is at your own risk.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                  4. Privacy
                </h2>
                <p className="text-gray-700">
                  We may collect personal information when you create an account or use our
                  services. Your data will be handled according to our Privacy Policy, which 
                  forms part of these Terms.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                  5. User Accounts
                </h2>
                <p className="text-gray-700">
                  You are responsible for keeping your account and password secure. Any 
                  activity under your account is your responsibility. Please notify us 
                  immediately if you suspect unauthorized use.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                  6. Third-Party Links
                </h2>
                <p className="text-gray-700">
                  Our website may contain links to third-party sites. We are not responsible 
                  for their content, security, or practices. Accessing these sites is at your own 
                  risk.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                  7. Prohibited Activities
                </h2>
                <p className="text-gray-700 mb-4">
                  You agree not to:
                </p>
                <ul className="list-disc pl-6 text-gray-700 space-y-2">
                  <li>Use the site for unlawful purposes</li>
                  <li>Attempt unauthorized access to accounts, servers, or networks</li>
                  <li>Distribute harmful software (viruses, worms, etc.)</li>
                  <li>Use automated tools (bots, crawlers) without permission</li>
                  <li>Impersonate another person or entity</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                  8. Intellectual Property
                </h2>
                <p className="text-gray-700">
                  All content, logos, and trademarks on this site belong to us or our licensors. 
                  You may not copy, modify, or use them for commercial purposes without 
                  written permission.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                  9. Disclaimer of Warranties
                </h2>
                <p className="text-gray-700">
                  Our website and services are provided "as is." We make no guarantees 
                  about reliability, accuracy, or availability.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                  10. Limitation of Liability
                </h2>
                <p className="text-gray-700">
                  We are not liable for any indirect, incidental, or consequential damages 
                  related to your use of our site. Our maximum liability to you is limited to the
                  amount you paid us in the last 12 months, or $100, whichever is greater.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                  11. Termination
                </h2>
                <p className="text-gray-700">
                  We may suspend or terminate your access at any time if you violate these 
                  Terms.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                  12. Governing Law
                </h2>
                <p className="text-gray-700">
                  These Terms are governed by the laws of [Your Jurisdiction]. Any disputes 
                  must be resolved in the courts of [Your Location].
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                  13. Refund Policy
                </h2>
                <p className="text-gray-700">
                  Refund requests must be made within [X days] of purchase, depending on 
                  the product or service. Refunds will be processed through the original 
                  payment method.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                  14. Contact
                </h2>
                <p className="text-gray-700">
                  For any questions, please contact us at [Your Contact Email].
                </p>
              </section>
            </div>
          </div>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default TermsOfService;
